module.exports = __webpack_public_path__ + "img/dialog-img-01.400e87c0.png";